module.exports = __webpack_public_path__ + "media/typy/budowlane-2d84e6f9.png";